﻿

(() => {
    angular.module('fliptoWeb')
        .controller('SuperchargersCtrl', ['$scope',
        function ($scope) {
            
        }]);
})()
